var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUbietyMarkColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#00e5d9;}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1423.5,
    y1: -1241.12,
    x2: -1201.85,
    y2: -1462.78,
    gradientTransform: "translate(2118.12 225.3) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ed300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1420.16,
    y1: -1244.47,
    x2: -1184.81,
    y2: -1479.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 179.12,
    y1: 354.27,
    x2: 529.73,
    y2: 3.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123,364.7v37a5.75,5.75,0,0,0,3.27,5.2,252.3,252.3,0,0,0,215.37-.25,5.74,5.74,0,0,0,3.26-5.2v-37a5.77,5.77,0,0,0-8.63-5,207.1,207.1,0,0,1-204.65.29A5.76,5.76,0,0,0,123,364.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123,180A111,111,0,1,0,234,69.09,111.07,111.07,0,0,0,123,180Zm177.58,0A66.63,66.63,0,1,1,234,113.41,66.71,66.71,0,0,1,300.58,180Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.23,208.71a40.93,40.93,0,1,0,0-57.89A40.91,40.91,0,0,0,205.23,208.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M407.77,222.2,380.7,187.46a5.78,5.78,0,0,0-10.32,3.16c0,.28-.06.56-.08.84l-.29-.13A136.52,136.52,0,0,1,134,273l-.09,0c-.26-.27-.53-.54-.78-.82A5.78,5.78,0,0,0,123,276.05v44a5.75,5.75,0,0,0,2.27,4.6,180.36,180.36,0,0,0,172.45,24.74l2.09-.79c.82-.32,1.64-.66,2.45-1A180.32,180.32,0,0,0,408.81,227.23,5.76,5.76,0,0,0,407.77,222.2Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbietyMarkColor);
export default __webpack_public_path__ + "static/media/ubiety-mark-color.495e620c6e6ae240d6ad0a1ecc442591.svg";
export { ForwardRef as ReactComponent };